<template>
  <div class="page-gallery">
    <div
      class="page-header header-accent-gradient card-base card-shadow--small"
    >
      <h1>Gallery</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"
          ><i class="mdi mdi-home-outline"></i
        ></el-breadcrumb-item>
        <el-breadcrumb-item>Apps</el-breadcrumb-item>
        <el-breadcrumb-item>Gallery</el-breadcrumb-item>
        <el-breadcrumb-item>Projects</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="flex justify-flex-end">
        <el-button type="primary" round icon="el-icon-plus" @click="add = true">
          Crear album</el-button
        >
      </div>
    </div>
    <div id="container">
      <el-drawer
        title="Nuevo Album"
        size="50%"
        direction="rtl"
        :visible.sync="add"
        :with-header="true"
      >
        <newAlbum
          @close="add = false"
          :albumType="1"
          @success="handleSuccess"
        ></newAlbum>
      </el-drawer>
      <ItemList v-loading="loading" :items="albums" @delete="handleDelete" />
      <h1 v-if="albums.length === 0">No hay album creado</h1>
    </div>
    <div class="photo-list">
      <profile-gallery></profile-gallery>
    </div>
  </div>
</template>

<script>
import newAlbum from "./NewAlbum";
import ItemList from "./GalleryItemList";

const TYPE_ALBUM_PROJECT = 1;

export default {
  name: "GalleryProjects",
  mounted() {
    this.getAlbumList();
  },
  data() {
    return {
      add: false,
      loading: true,
      albums: []
    };
  },
  components: {
    newAlbum,
    ItemList
  },
  methods: {
    handleDelete() {
      this.loading = true;
      this.getAlbumList();
    },
    getAlbumList() {
      const api = `/api/gallery/Albums`;
      this.$http
        .get(api, {
          params: {
            albumType: TYPE_ALBUM_PROJECT,
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.albums = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
          this.loading = false;
        });
    },
    handleSuccess() {
      this.getAlbumList();
    }
  }
};
</script>

<style lang="scss" scoped>
/*.photo-list {
	//padding: 20px;
}*/
</style>
